const formatHeader = (text) => {
  if (typeof text !== 'string') {
    throw new Error('Invalid input. The text parameter must be a string.');
  }
  // @TODO 2024-04-19: Julia Removed 'is' from the list of words to ignore to format the homepage header 'Summer is here', re-add it after the summer season.
  const wordsToIgnore = ['the', 'by', 'to', 'its', 'through', 'into', 'in', 'at', 'on', 'of', 'for', 'and', 'near', 'a', 'an', 'with', 'here', 'de', 'la'];

  const formattedHeader = text.replace(
    /\b\w+\b|([a-zA-Z]|[à-ü]|[À-Ü])/g,
    (word) => {
      const lowerCaseWord = word.toLowerCase();
      if (wordsToIgnore.includes(lowerCaseWord)) {
        return word;
      }
      return `<span class="formatHeader">${word}</span>`;
    },
  );
  return formattedHeader;
};

export { formatHeader };
